import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Rooms from "./pages/Rooms";
import Contact from "./pages/Contact";
import NewDining from "./pages/NewDining";
import Events from "./pages/Events";
import BookYourStay from "./pages/BookYourStay";
import Partners from "./pages/Partners";
import More from "./pages/More";
import FamilyRoom from "./pages/room-details/FamilyRoom";
import DoubleRoom from "./pages/room-details/DoubleRoom";
import SingleRoom from "./pages/room-details/SingleRoom";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/rooms" element={<Rooms />} />
            <Route path="/dining" element={<NewDining />} />
            <Route path="/events" element={<Events />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/more" element={<More />} />
            <Route path="/book" element={<BookYourStay />} />
            <Route path="/rooms/family" element={<FamilyRoom />} />
            <Route path="/rooms/double" element={<DoubleRoom />} />
            <Route path="/rooms/single" element={<SingleRoom />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
